import { render, staticRenderFns } from "./TkQueryDate.vue?vue&type=template&id=f2a24864&scoped=true&"
import script from "./TkQueryDate.vue?vue&type=script&lang=js&"
export * from "./TkQueryDate.vue?vue&type=script&lang=js&"
import style0 from "./TkQueryDate.vue?vue&type=style&index=0&id=f2a24864&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a24864",
  null
  
)

export default component.exports